import * as React from 'react';

type FlagSwedenProps = {
    size?: number | string;
    title?: string;
    className?: string;
    style?: React.CSSProperties;
};

function SwedishFlag({
  size = 24,
  title = 'Swedish flag',
  className,
  style,
}: FlagSwedenProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  // Reduced thickness for slightly slimmer inner yellow lines; offsets nudged to keep bars visible in round container
  const crossThickness = 1.2;
  const verticalX = 5.4;
  const horizontalY = 3.8;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        overflow: 'hidden',
        lineHeight: 0,
        borderRadius: '50%',
        ...style,
      }}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 16 10'
        preserveAspectRatio='xMidYMid slice'
        xmlns='http://www.w3.org/2000/svg'
        style={{ display: 'block' }}
      >
        <title>{title}</title>
        <rect width='16' height='10' fill='#0058A3' />
        <rect x={0} y={horizontalY} width='16' height={crossThickness} fill='#FECB00' />
        <rect x={verticalX} y={0} width={crossThickness} height='10' fill='#FECB00' />
      </svg>
    </span>
  );
}

export default SwedishFlag;
